module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('div', {
      staticClass: "font-medium whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.user_created_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.total))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.finishTasks(task.user_created.id)
        }
      }
    }, [_vm._v("\n                  Finalizar todas\n                ")])])])
  }), 0)])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("# TAREAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca5db4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/TaskWithoutFinish.vue
// module id = 415
// module chunks = 1